import { FormEvent, useMemo, useState } from "react";
import "./AccessCodeEntry.css";

type Props = {
    onSubmit: (code: string) => void | Promise<void>;
    error?: string;
    isSubmitting?: boolean;
    title?: string;
    subtitle?: string;
};

export function AccessCodeEntry({
    onSubmit,
    error,
    isSubmitting = false,
    title = "Private Homepage",
    subtitle = "The site you are trying to visit is private. Please provide an access code to view this site.",
}: Props) {
    const [code, setCode] = useState("");

    const canSubmit = useMemo(() => code.trim().length > 0 && !isSubmitting, [code, isSubmitting]);

    const handleSubmit = (e: FormEvent) => {
        e.preventDefault();
        void onSubmit(code);
    };

    return (
        <div className="entry">
            <div className="panel">
                <h1 className="title">{title}</h1>
                <p className="subtitle">{subtitle}</p>

                <form onSubmit={handleSubmit}>
                    <label htmlFor="access-code" className="form-label">
                        Access code
                    </label>

                    <input
                        value={code}
                        onChange={(e) => setCode(e.target.value)}
                        autoFocus
                        inputMode="text"
                        autoCapitalize="none"
                        autoCorrect="off"
                        spellCheck={false}
                        placeholder="e.g. ABC123"
                        className="form-input"
                        id="access-code"
                    />

                    {error ? <div className="form-error">{error}</div> : null}

                    <button type="submit" disabled={!canSubmit} className="form-submit">
                        {isSubmitting ? "Checking…" : "Continue"}
                    </button>
                </form>
            </div>
        </div>
    );
}
